// src/store/aiTip/aiTipSlice.js
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAITips,
  fetchTipById,
  submitTipFeedback,
  createTip
} from './aiTipThunk';

const initialState = {
  tips: [],
  currentTip: null,
  loading: false,
  createLoading: false,
  feedbackLoading: false,
  error: null,
  createError: null,
  feedbackError: null,
  successMessage: null,
  total: 0
};

const aiTipSlice = createSlice({
  name: 'aiTip',
  initialState,
  reducers: {
    setCurrentTip: (state, action) => {
      state.currentTip = action.payload;
    },
    
    clearCurrentTip: (state) => {
      state.currentTip = null;
    },
    
    clearError: (state) => {
      state.error = null;
      state.createError = null;
      state.feedbackError = null;
    },
    
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    }
  },
  
  extraReducers: (builder) => {
    // FETCH ALL TIPS
    builder
      .addCase(fetchAITips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAITips.fulfilled, (state, action) => {
        state.loading = false;
        state.tips = action.payload?.tips || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(fetchAITips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch tips';
        state.tips = [];
        state.total = 0;
      })
    
    // FETCH TIP BY ID
      .addCase(fetchTipById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTipById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentTip = action.payload?.tip || null;
      })
      .addCase(fetchTipById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch tip';
        state.currentTip = null;
      })
    
    // SUBMIT TIP FEEDBACK
      .addCase(submitTipFeedback.pending, (state) => {
        state.feedbackLoading = true;
        state.feedbackError = null;
        state.successMessage = null;
      })
      .addCase(submitTipFeedback.fulfilled, (state, action) => {
        state.feedbackLoading = false;
        state.successMessage = action.payload?.message || 'Feedback submitted';
      })
      .addCase(submitTipFeedback.rejected, (state, action) => {
        state.feedbackLoading = false;
        state.feedbackError = action.payload || 'Failed to submit feedback';
      })
    
    // CREATE TIP
      .addCase(createTip.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
        state.successMessage = null;
      })
      .addCase(createTip.fulfilled, (state, action) => {
        state.createLoading = false;
        state.successMessage = action.payload.message || 'Tip created successfully';
        
        // Add to tips list
        if (action.payload.tip) {
          state.tips.unshift(action.payload.tip);
          state.total += 1;
        }
      })
      .addCase(createTip.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload || 'Failed to create tip';
      });
  }
});

// Actions
export const {
  setCurrentTip,
  clearCurrentTip,
  clearError,
  clearSuccessMessage
} = aiTipSlice.actions;

// Selectors
export const selectTips = (state) => state.aiTip.tips;
export const selectCurrentTip = (state) => state.aiTip.currentTip;
export const selectTipLoading = (state) => state.aiTip.loading;
export const selectCreateLoading = (state) => state.aiTip.createLoading;
export const selectFeedbackLoading = (state) => state.aiTip.feedbackLoading;
export const selectTipError = (state) => state.aiTip.error;
export const selectCreateError = (state) => state.aiTip.createError;
export const selectFeedbackError = (state) => state.aiTip.feedbackError;
export const selectSuccessMessage = (state) => state.aiTip.successMessage;
export const selectTotal = (state) => state.aiTip.total;

export default aiTipSlice.reducer;